import { CaretDownIcon } from "@phosphor-icons/react";

type Props = React.ComponentProps<typeof CaretDownIcon>;

export const SelectIcon = (props: Props) => (
  <CaretDownIcon {...props} size={20} weight="bold" />
);
